<template>
  <div id="app">
    <div
      class="header-aside"
      v-if="isShowMenu"
    >
      <header>
        <div class="head-left">
          <i class="icon-banner"></i>
        </div>
        <div class="head-right">
          <el-dropdown @command="handleCommand">
            <div class="el-dropdown-link">
              <div class="pull-left">
                <!--<div class="title">熙盟科技</div>-->
                <div class="role">{{user.name||'---'}}</div>
              </div>
              <div class="pull-left dropdown-icon">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="quit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>
      <el-menu class="aside" :default-active="active"
               background-color="#364760" text-color="#fff"
               :router="true">
        <el-menu-item index="/home">
          <i class="icon icon-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/house">
          <i class="icon icon-house"></i>
          <span slot="title">房产管理</span>
        </el-menu-item>
        <el-menu-item index="/rooms">
          <i class="icon icon-room"></i>
          <span slot="title">房间管理</span>
        </el-menu-item>
        <!--<el-menu-item index="/account">
          <i class="icon icon-account"></i>
          <span slot="title">帐号管理</span>
        </el-menu-item>-->
        <el-menu-item index="/facility">
          <i class="icon el-icon-mobile-phone"></i>
          <span slot="title">NB房间管理</span>
        </el-menu-item>
        <el-menu-item index="/log">
          <i class="icon icon-log"></i>
          <span slot="title">系统日志</span>
        </el-menu-item>
        <el-menu-item index="/person">
          <i class="icon icon-person"></i>
          <span slot="title">个人中心</span>
        </el-menu-item>
        <el-menu-item index="/approval" v-if="user.account === 'admin'">
          <i class="icon icon-person"></i>
          <span slot="title">帐号审批</span>
        </el-menu-item>
      </el-menu>
    </div>

    <div class="router-view">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {userPost} from 'common/ajax/methods'
import {mapGetters} from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      active: ''
    }
  },
  computed: {
    route () {
      return this.$route
    },
    isShowMenu () {
      const name = this.$route.name
      return (
        name !== 'Login' &&
        name !== 'Register' &&
        name !== 'Open' &&
        name !== 'ForgetPassword' &&
        name !== 'ApprovalLogin' &&
        name !== 'ApprovalForgetPwd'
      )
    },
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    handleCommand (command) {
      if (command === 'quit') {
        userPost('/user/logout', {}).then((res) => {
          if (res.code === 0) {
            this.$router.push({path: '/'})
          }
        })
      }
    }
  },
  watch: {
    route (newVal) {
      this.active = '/' + newVal.name.split('/')[0].toLowerCase()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  #app
    overflow: hidden;

    .header-aside
      header
        position fixed
        left 0
        z-index 10
        width 100%
        height 55px
        background-color #364760

        .head-left
          display flex
          justify-content center
          align-items center
          float left
          width 200px
          height 55px
          background-color #2a394f

          .icon-banner
            display inline-block
            width 116px;
            height 22px
            background-image url("./common/images/icons-2.png")
            background-position -166px -108px

        .head-right
          float right
          width 130px

          .el-dropdown-link
            color #fff
            overflow hidden

            .title
              margin-top 12px
              opacity .9
              font-size 16px

            .role
              margin-top 19px
              opacity .9
              font-size 14px

            .dropdown-icon
              margin-top 20px
              margin-left 5px

      .aside
        position fixed
        top 0
        left 0
        bottom 0
        z-index 9
        width 200px
        padding-top 55px
        border none
        box-sizing border-box

        .el-menu-item
          .icon
            margin-right: 6px;
            display inline-block
            width: 18px;
            height: 18px;
            background: url("./common/images/icons-2.png") no-repeat;

            &.icon-home
              background-position -181px -20px

            &.icon-house
              background-position -213px -21px

            &.icon-room
              background-position -242px -21px

            &.icon-log
              background-position -305px -21px

            &.icon-person
              background-position -273px -21px

          &.is-active
            .icon-home
              background-position -25px -21px

            .icon-house
              background-position -57px -22px

            .icon-room
              background-position -86px -22px

            .icon-log
              background-position -149px -22px

            .icon-person
              background-position -117px -22px

    .router-view
      padding-top 55px
      padding-left 200px
      width 100%
      box-sizing border-box
      overflow hidden
</style>



// WEBPACK FOOTER //
// src/App.vue